import { Progress as FASTProgress } from '@microsoft/fast-components';
import { foundationProgressStyles as styles } from './progress.styles';
import { foundationProgressTemplate as template } from './progress.template';
/**
 * @tagname %%prefix%%-progress
 */
export class Progress extends FASTProgress {
}
// explicitly declaring for extensibility
export const foundationProgressShadowOptions = undefined;
export const defaultProgressConfig = {
    indeterminateIndicator1: `<span class="indeterminate-indicator-1" part="indeterminate-indicator-1"></span>`,
    indeterminateIndicator2: `<span class="indeterminate-indicator-1" part="indeterminate-indicator-1"></span>`,
};
/**
 * The Foundation Progress
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-progress\>
 */
export const foundationProgress = Progress.compose(Object.assign({ baseName: 'progress', template,
    styles, shadowOptions: foundationProgressShadowOptions }, defaultProgressConfig));
